package one.devsbox.shared.files


@Suppress("ClassName")
sealed class Resolutions(
    val name: String,
    val w: Int,
    val h: Int,
) {

    // --- Landscape Resolutions (From Image) ---
    data object _HVGA : Resolutions("HVGA", 480, 320)
    data object _VGA : Resolutions("VGA", 640, 480)
    data object _SVGA : Resolutions("SVGA", 800, 600)
    data object _HD : Resolutions("HD", 1280, 720)
    data object _FHD : Resolutions("FHD", 1920, 1080)
    data object _2K_QHD : Resolutions("QHD", 2560, 1440)
    data object _4K_UHD : Resolutions("UHD", 3840, 2160)

    // --- Portrait Resolutions ---
    data object _HVGA_P : Resolutions("HVGA", 320, 480)
    data object _VGA_P : Resolutions("VGA", 480, 640)
    data object _SVGA_P : Resolutions("SVGA", 600, 800)
    data object _HD_P : Resolutions("HD", 720, 1280)
    data object _FHD_P : Resolutions("FHD", 1080, 1920)
    data object _2K_QHD_P : Resolutions("QHD", 1440, 2560)
    data object _4K_UHD_P : Resolutions("UHD", 2160, 3840)

    class Custom(width: Int, height: Int) : Resolutions("Custom", width, height)

    override fun toString() = "$name ($w x $h)"

    companion object {
        val horizontal
            get() = listOf(
                _HVGA, _VGA, _SVGA, _HD, _FHD, _2K_QHD, _4K_UHD
            )

        val vertical
            get() = listOf(
                _HVGA_P, _VGA_P, _SVGA_P, _HD_P, _FHD_P, _2K_QHD_P, _4K_UHD_P
            )

        val all get() = horizontal + vertical

        /**
         * Finds the exact matching standard resolution, or returns Custom.
         */
        fun fromDimensions(width: Int, height: Int): Resolutions {
            return all.firstOrNull { it.w == width && it.h == height }
                ?: Custom(width, height)
        }

        /**
         * Finds the closest standard resolution based on pixel distance (Euclidean distance).
         */
        fun closestStandard(width: Int, height: Int): Resolutions {
            val exact = fromDimensions(width, height)
            if (exact is Custom) {
                if (width <= 0 || height <= 0) return _FHD // Fallback safe default

                // Find the standard resolution with the minimum geometric distance
                return all.minByOrNull { standard ->
                    val dw = (standard.w - width).toDouble()
                    val dh = (standard.h - height).toDouble()
                    kotlin.math.sqrt(dw * dw + dh * dh)
                } ?: exact
            }
            return exact
        }
    }
}